import React, { useContext, useEffect, useState } from "react";
import "./Profile.css";
import White_Btn from "../../../common_components/common_btn/white_btn/White_Btn";
import Verification_Steps_Modal from "../../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import Verify_Profile_Modal from "../../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Success_Lottie from "../../../animation/success_lottie/Success_Lottie";
import { getUserData } from "../../../../utils/apis/common/Common";
import { Context } from "../../../../utils/context";

const Profile = () => {
  const [showModal, setShowModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [stepCompleted, setStepCompleted] = useState(false);

  const { IMG_URL, userdata } = useContext(Context);

  useEffect(() => {
    if (formSubmitted) {
      setShowSuccessModal(true);
    }

    setTimeout(() => {
      setFormSubmitted(false);
    }, 5000);
  }, [formSubmitted]);

  return (
    <section className="Profile">
      <div className="info_outer_div">
        <div className="top_head_section">
          <div className="left_side">
            <div className="img_holder">
              <img
                src="/assets/images/settings/check.png"
                className="check_img"
              />
            </div>
            <p className="section_title">Personal Details</p>
          </div>
        </div>

        <div className="info_inner_div">
          <div className="row">
            <div className="col-md-6 custom_col">
              <div className="label_holder">
                <p className="label_text">Contact Number:</p>
                <p className="label_text">+91 {userdata?.contact_no}</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="label_holder">
                <p className="label_text">Email Address:</p>
                <p className="label_text">{userdata?.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="info_outer_div incomplete">
        <div
          className={`top_head_section ${
            !userdata?.accept_or_reject ? "incomplete" : ""
          }`}
        >
          <div className="left_side">
            <div className="img_holder">
              <img
                src="/assets/images/settings/check.png"
                className="check_img"
              />
            </div>
            {userdata?.accept_or_reject == false ? (
              <p className="section_title">Verify Your Identity</p>
            ) : (
              <p className="section_title">Identity Verified</p>
            )}
          </div>
        </div>

        <div className="info_inner_div">
          <div className="data_info_div">
            <div className="left_div">
              {userdata?.accept_or_reject == false && (
                <p className="light_white_text">
                  Provide a document confirming your name
                </p>
              )}
              {userdata?.accept_or_reject == false ? (
                <p className="text-danger">
                  Your Profile Has Been Rejected. Please Update.
                </p>
              ) : (
                "Profile Verified"
              )}
              <p className="section_title">
                {" "}
                {userdata?.first_name} {userdata?.last_name}
              </p>
            </div>
            {userdata?.accept_or_reject === 2 ? (
              <div className="btn_holder">
                <White_Btn
                  btn_name="Complete Now"
                  onClick={() => setShowModal(true)}
                />
              </div>
            ) : userdata?.accept_or_reject == false ? (
              <div className="btn_holder">
                <White_Btn
                  btn_name="Update Profile"
                  onClick={() => setShowModal(true)}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <Verify_Profile_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        setFormSubmitted={setFormSubmitted}
        setStepCompleted={setStepCompleted}
      />

      <Successfull_Modal
        message="Profile Doc Send For Verification Successfully"
        show={showSuccessModal}
        onHide={() => {
          setShowSuccessModal(false);
        }}
        lottie={<Success_Lottie />}
      />
    </section>
  );
};

export default Profile;
